import { render, staticRenderFns } from "./SmartService.vue?vue&type=template&id=133c5446&scoped=true&"
import script from "./SmartService.vue?vue&type=script&lang=js&"
export * from "./SmartService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133c5446",
  null
  
)

export default component.exports